import {useEffect, useState} from 'react'
import {AxiosError} from 'axios'
import {useIntl} from 'react-intl'
import DataTable, {TableColumn} from 'react-data-table-component'
import {useLocation, useNavigate} from 'react-router-dom'
import {useLang} from '../../../_metronic/i18n/Metronici18n'
import {listContent} from '../../modules/auth/core/_requests'
import {customStyles} from '../../../dataTableStyle'
import {KTSVG} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import AddContentModal from './Modals/ContentModals/AddContentModal'
import ContentEditModal from './Modals/ContentModals/ContentEditModal'
import ContentDeletionModal from './Modals/ContentModals/ContentDeletionModal'

type ContentType = {
  id: number
  contentTitle: string
  metadata: string
  spot: string
}

function Content() {
  const intl = useIntl()
  const lang = useLang()
  const navigate = useNavigate()
  const {state}: any = useLocation()

  const [contentList, setContentList] = useState([])
  const [isChecked, setISChecked] = useState<Array<string>>([])
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [action, setAction] = useState(true)
  const [page, setPage] = useState(state?.page ?? 1)
  const [rowsPerPage, setRowsPerPage] = useState(state?.rowsPerPage ?? 5)

  // 👇  Herhangi Bir Aksiyon Sonrası Listeyi Yenile
  useEffect(() => {
    if (action) {
      getList()
      setAction(false)
      setISChecked([])
    }
  }, [action])

  // 👇 Content Bilgilerini Al
  const getList = async () => {
    try {
      const {data} = await listContent(0, '', lang, '')
      setContentList(data)
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  // 👇  Arama İşlemleri
  const keys = ['metadata', 'contentTitle']

  const search = (list: any) => {
    if (searchTerm) {
      return contentList.filter((item: any) =>
        keys.some((key) => item[key].toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))
      )
    } else {
      return contentList
    }
  }

  // 👇  Tablo Satırlarını Oluştur
  const columns: TableColumn<ContentType>[] = [
    {
      name: 'ID',
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: 'Name',
      cell: (row) => (
        <a
          style={{cursor: 'pointer'}}
          className=' link-primary'
          /*
          onClick={
            () =>
              navigate(`/management/content/selected-content`, {state: {row, page, rowsPerPage}})
            //  window.localStorage.setItem('contentData', JSON.stringify(row))
          }*/
          onClick={
            () => navigate(`/management/content/${row.id}`, {state: {row, page, rowsPerPage}})
            //  window.localStorage.setItem('contentData', JSON.stringify(row))
          }
        >
          {row.contentTitle}
        </a>
      ),
      sortable: true,
    },

    {
      name: 'Metadata',
      selector: (row) => row.metadata,
      sortable: true,
    },
    {
      name: 'Spot',
      cell: (row) => <div dangerouslySetInnerHTML={{__html: row.spot}} />,
      sortable: true,
    },
  ]

  // 👇 Tablodan Seçili Id Kaydet
  const handleSelectId = ({selectedRows}: any) => {
    setISChecked(selectedRows.map((selected: any) => selected.id))
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.CONTENT'})}</PageTitle>
      <div className='card card-custom gx-xl-10 mt-lg-n16 mt-2'>
        <div className='card-header row p-5 '>
          <div className='d-flex flex-column flex-md-row justify-content-sm-between align-items-sm-center'>
            {/* 👇 Refresh Button - Search Bar 👇 */}
            <div className='d-flex align-items-center'>
              <button
                type='button'
                className='btn btn-light m-2 square border border-secondary'
                onClick={() => setAction(true)}
              >
                <i className='fa-solid fa-rotate-right' />
              </button>
              <div className='d-flex bg-light align-items-center rounded position-relative square border border-secondary w-100 w-xl-450px'>
                <KTSVG
                  path='/media/icons/duotune/general/gen021.svg'
                  className='svg-icon-1 position-absolute ms-5'
                />
                <input
                  type='text'
                  data-kt-user-table-filter='search'
                  className='form-control form-control-solid ps-14'
                  placeholder='Search'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            {/* 👆 Refresh Button - Search Bar 👆 */}
            {/* 👇 Delete - Edit - Add Buttons 👇 */}
            <div className='d-flex flex-column flex-md-row'>
              <button
                type='button'
                className='btn btn-light-warning m-2'
                disabled={isChecked.length === 1 ? false : true}
                data-bs-toggle='modal'
                data-bs-target='#updateContent_modal'
              >
                Edit
              </button>
              <button
                type='button'
                className='btn btn-light-danger m-2'
                disabled={isChecked.length > 0 ? false : true}
                data-bs-toggle='modal'
                data-bs-target='#deleteContent_modal'
              >
                Delete
              </button>
              <button
                type='button'
                className='btn btn-light-primary m-2'
                data-bs-toggle='modal'
                data-bs-target='#createContent_modal'
              >
                Create Content
              </button>
            </div>
            {/* 👆 Delete - Edit - Add Buttons 👆 */}
          </div>
        </div>

        <div className='card-body table-responsive'>
          <DataTable
            className='table table-striped'
            customStyles={customStyles}
            columns={columns}
            data={search(contentList)}
            pagination
            paginationRowsPerPageOptions={[5, 10, 25, 50, 100]}
            striped
            selectableRows
            onSelectedRowsChange={handleSelectId}
            paginationDefaultPage={page}
            onChangePage={(e) => setPage(e)}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={(e) => setRowsPerPage(e)}
          />
        </div>
        {/*Create Experiment Modal */}
        <AddContentModal setAction={setAction} />
        {/*Update Experiment Modal */}
        <ContentEditModal
          editData={
            isChecked ? contentList.filter((item: any) => item.id === Number(isChecked[0]))[0] : []
          }
          setAction={setAction}
        />
        {/*Delete Experiment Modal */}
        <ContentDeletionModal checkList={isChecked} setAction={setAction} />
      </div>
    </>
  )
}

export default Content
